import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { useDecision } from '@optimizely/react-sdk'
import CustomAlert from '@space-lib/components/customAlert'
import useTranslation from '@space-lib/hooks/useTranslation'

import { AccessHeader } from './components/accessHeader'
import AccessSection from './components/accessSection'
import { PAGE_VIEW_ACCESS_SECTION } from './components/accessSection/types'
import { ChangeCommunityTypeContainer } from './components/changeCommunityTypeContainer'
import Courses from './components/courses'
import HeaderAccessAndPrivacy from './components/headerAccessAndPrivacy'
import OpenCommunityState from './components/openCommunityState'
import { COMMUNITY_TYPE, COMMUNITY_TYPES_LIST } from './constants'
import { Container, ContainerAccessSection } from './styles'
import type { AccessAndPrivacyProps } from './types'

import useCommunityConfigurationSidebar from '../communityConfigurationSidebar/hooks/useConfigurationCommunitySidebar/useCommunityConfigurationSidebar'

const AccessAndPrivacy = ({ isOpen }: AccessAndPrivacyProps) => {
  const { t } = useTranslation()
  const { community } = useCommunityConfigurationSidebar()

  const [{ enabled: isEnabledChangeCommunityType }] = useDecision(
    'com_adm_web_enable_change_community_type'
  )

  const CommunitiesList = COMMUNITY_TYPES_LIST({
    showPaidCommunityFlag: community.type === COMMUNITY_TYPE.PAID,
    showPublicCommunityFlag: community.type === COMMUNITY_TYPE.PUBLIC
  }).filter((item) => item.show)

  return (
    <Container>
      {isEnabledChangeCommunityType ? (
        <>
          <AccessHeader />
          <ChangeCommunityTypeContainer />
        </>
      ) : (
        <>
          <HeaderAccessAndPrivacy />
          <CustomAlert icon={faCircleInfo} iconClassName='fa-lg' className='_mb-5'>
            <p className='_mb-0 _font-weight _text-2 _text-gray-700'>
              {t('configuration_sidebar.access_and_privacy.community_privacy_alert')}
            </p>
          </CustomAlert>
          <ContainerAccessSection className='_d-flex _flex-column _mb-7'>
            {CommunitiesList.map((item) => {
              return (
                <AccessSection
                  title={item.title}
                  description={item.description}
                  key={item.title}
                  checked={item.type === community.type}
                  disabled={!(item.type === community.type)}
                  value={item.type}
                  page={PAGE_VIEW_ACCESS_SECTION.SIDEBAR}
                />
              )
            })}
          </ContainerAccessSection>
        </>
      )}
      <div className='_border-bottom' />
      {community.type === COMMUNITY_TYPE.EXCLUSIVE ? (
        <Courses isOpen={isOpen} />
      ) : (
        <OpenCommunityState />
      )}
    </Container>
  )
}

export default AccessAndPrivacy
